import logo_chrome from '@/assets/images/logo_chrome.png';
import ErrorPage from '@/components/home/error';
import { ConfigProvider, Modal } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { RouterView } from 'vue-router';
import { ISWELCOME } from './hooks/auth/index';
import { sendLog } from './log';
import { globalLog } from './log/pages/common';
import { BrowserDetect } from './utils/getBrowser';
import { mouseMoveFn } from './utils/mouseMove';

// const console = new ConsoleLogger('app.tsx');

export default defineComponent({
  name: 'App',
  setup() {
    const errorHappened = ref<boolean>(false);
    const errorMessage = ref<string>('');

    const handleBodyClick = (e: any) => {
      const clientWidth = document.body.clientWidth;
      const clientHeight = document.body.clientHeight;
      sendLog(globalLog.bodyClick, { x: e?.pageX, y: e?.pageY, clientWidth, clientHeight });
    };

    const handleDbClick = (e: MouseEvent) => {
      sendLog(globalLog.doubleClick, { x: e?.pageX, y: e?.pageY });
    };
    const handleContextMenu = (e: MouseEvent) => {
      sendLog(globalLog.rightClick, { x: e?.pageX, y: e?.pageY });
    };
    const handleCopy = (e: ClipboardEvent) => {
      sendLog(globalLog.copy);
    };

    onMounted(() => {
      // 全局监听鼠标滑动事件
      document.addEventListener('mousemove', mouseMoveFn);
      // 先暂时用几天，跑热点图，然后可以删除
      document.body.addEventListener('click', handleBodyClick);
      // 全局监听双击事件
      document.addEventListener('dblclick', handleDbClick);
      // 全局监听鼠标右键事件
      document.addEventListener('contextmenu', handleContextMenu);
      // 全局监听复制事件
      document.addEventListener('copy', handleCopy);

      if (!localStorage.getItem(ISWELCOME)) {
        BrowserDetect.init();
        if (BrowserDetect.OS !== 'Windows' && BrowserDetect.OS !== 'Mac') {
          // 表示不是pc
          Modal.warning({
            title: '温馨提示',
            content: `您正在通过移动设备访问教师工作台，可能产生未知的问题，请您使用电脑上的谷歌浏览器进行使用`
          });
        } else {
          if (BrowserDetect.browser !== 'Chrome' || BrowserDetect.version < 100) {
            // 表示浏览器符合要求
            Modal.confirm({
              class: 'browser',
              okText: (
                <a download={'chrome.exe'} href="https://res.xiwang.com/chrome/chrome_installer_110.exe">
                  下载 <span class="iconfont icon-icon_download" style={{ verticalAlign: 'top' }}></span>
                </a>
              ),
              cancelText: null,
              closable: true,
              title: <h2 style={{ textAlign: 'center' }}>发现更好的使用体验</h2>,
              content: (
                <p>
                  <span>推荐下载安装最新版本</span> <img style={{ width: '16px', display: 'inline', marginTop: '-3px' }} src={logo_chrome} alt="" />
                  <span>chrome获得更良好的使用体验</span>{' '}
                </p>
              ),
              icon: null,
              onOk: () => {}
            });
          }
        }
      }
    });

    onUnmounted(() => {
      document.removeEventListener('mousemove', mouseMoveFn);
      document.body.removeEventListener('click', handleBodyClick);
      document.removeEventListener('dblclick', handleDbClick);
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('copy', handleCopy);
    });

    function renderNormalPage() {
      return (
        <ConfigProvider locale={zhCN}>
          <RouterView></RouterView>
        </ConfigProvider>
      );
    }
    // onErrorCaptured((err, instance, info) => {
    //   // 会渲染错误页面
    //   // errorMessage.value = `抱歉，页面发生错误：${err.message}，请联系开发老师～`;
    //   // errorHappened.value = true;
    //   notification['error']({
    //     message: '抱歉，页面发生错误，请联系开发老师～',
    //     description: `${err.message}`
    //   });
    //   console.log('onErrorCaptured', LOGLEVEL.error, err);
    //   // 手动上报错误
    //   __bl.error(err, {});
    //   return false;
    // });

    function renderErrorPage() {
      return <ErrorPage message={errorMessage.value} />;
    }

    return () => <>{errorHappened.value ? renderErrorPage() : renderNormalPage()}</>;
  }
});
